// @flow

import React, { Component }      from 'react';
import { connect }               from 'react-redux';
import { getTranslate }          from 'react-localize-redux';
import iconsHelper               from 'helpers/icons.helper';
import moment                    from 'moment';

class CompanyRowActivities extends Component {

  constructor() {
    super();

    this._renderActivities = this._renderActivities.bind(this);
    this._returnDefaultSuccessLogs = this._returnDefaultSuccessLogs.bind(this);
    this._returnActivities = this._returnActivities.bind(this);
  }

  render() {
    const { appCompany } = this.props;
    return (
      <div>
        {this._returnActivities(appCompany)}
      </div>
    );
  }

  _returnActivities = (app: Object) => {
    const activity_logs = app.ows_activity_logs;
    let logs = activity_logs.length > 0 ? activity_logs : this._getDefaultLogs(app);

    return logs.map(this._renderActivities);
  }

  _renderActivities = (log: Object) => {
    const { translate } = this.props;
    let formattedDate = moment(log.created_at).format(translate('common.date_output'));
    if (log.secondary_status === 8 || log.activity === "Vundet emne") { return null };

    return (
      <li key={log.id}>
        <i className={`ico ${iconsHelper[log.activity]}`}></i>
        <h4>{translate("applications." + log.activity)}</h4>
        <p>{formattedDate}</p>
      </li>
    )
  }

  _getDefaultLogs = (app: Object) => {
    if (app.primary_webservice_status.status === 'rejected') {
      return this._returnDefaultRejectedLogs(app);
    } else {
      return this._returnDefaultSuccessLogs(app);
    }
  }

  _returnDefaultRejectedLogs = (app: Object) => {
    let defLogs = this._startLog(app);

    defLogs.unshift({
      "id": moment(app.primary_webservice_status.time).unix(),
      "activity": 'reject',
      "created_at": app.primary_webservice_status.time
    });

    return defLogs;
  }

  _returnDefaultSuccessLogs = (app: Object) => {
    let defLogs = this._startLog(app);

    if (app.primary_webservice_status.status === 'success') {
      defLogs.unshift({
        "id": moment(app.primary_webservice_status.time).unix() + 'success',
        "activity": 'success',
        "created_at": app.primary_webservice_status.time
      })
    }

    return defLogs;
  }

  _startLog(app: Object) {
    return [{
      "id": moment(app.primary_webservice_status.time).unix(),
      "activity": 'match',
      "created_at": app.primary_webservice_status.time
    }];
  }
}

const mapStateToProps = state => ({
  translate: getTranslate(state.locale),
});

export default connect(mapStateToProps)(CompanyRowActivities);



// WEBPACK FOOTER //
// ./src/components/main/InsuranceInquiry/companyRowActivities.js